import styled from '@emotion/styled';

export const Template = styled.div`
    width: 100%;
    aspect-ratio: 16/9;
    background: #fff;
    border: ${({ selected, index }) => selected === index ? '1px solid #F7B035' : '1px solid #968F8F'};
    margin-bottom: 0.5rem;
`;
